var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-table-search',{attrs:{"title":"Liste des associations","items":_vm.assos,"fields":_vm.fields,"actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }